import { useState, useEffect } from 'react'
import styles from './NotificationList.module.scss'
import { PAGES_ROUTES } from '../../../Constants'
import { useNavigate } from 'react-router-dom'
import notificationFlag from '../../../Assets/Images/notificationFlag.gif'
import { NOTIFICATIONS } from '../../../Constants/ApiDefinations'
import mainApiService from '../../../Services'
import { NotificationTabType } from '../../../Models/CommonListHeadingModal'
import { logger } from '../../../Helpers'

const NotificationList = ({ onClose }: { onClose?: () => void }) => {
  const [tab, setTab] = useState<NotificationTabType>('my')
  const [notifications, setNotifications] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const moduleRouteMap: Record<string, string> = {
    widget: PAGES_ROUTES.ManageWidget,
    container: PAGES_ROUTES.ManageContainer,
    sitenavigation: PAGES_ROUTES.SiteNavigation,
    bulkoperation: PAGES_ROUTES.BulkOperation,
  }

  const fetchNotifications = async (myNotification: boolean) => {
    setLoading(true)
    try {
      const payload = { myNotification, sortType: -1, page: 1, limit: 10 }
      const notificationList = NOTIFICATIONS.NOTIFICATION_LIST(payload)
      const response: any = await mainApiService(notificationList)
      setNotifications(response?.data?.notifications ?? [])
    } catch (error) {
      setNotifications([])
      logger.error(error)
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchNotifications(tab === 'my')
  }, [tab])

  const handleMarkAllAsRead = async () => {
    try {
      const payload = { markAllAsRead: true }
      await mainApiService(NOTIFICATIONS.NOTIFICATION_MARK_AS_READ(payload))
      fetchNotifications(tab === 'my')
    } catch (error) {
      console.error('error', error)
    }
  }

  const handleNotificationClick = async (notif: any) => {
    try {
      const notificationId = notif?.userNotificationStatus?.notificationId
      if (notificationId) {
        const payload = { markAllAsRead: false, notificationId }
        await mainApiService(NOTIFICATIONS.NOTIFICATION_MARK_AS_READ(payload))
        setNotifications((prev) =>
          prev.map((data) =>
            data?.userNotificationStatus?.notificationId === notificationId
              ? {
                  ...data,
                  userNotificationStatus: {
                    ...data.userNotificationStatus,
                    isRead: true,
                  },
                }
              : data,
          ),
        )
      }
      const module = (notif?.module || '').toLowerCase()
      const baseRoute = moduleRouteMap[module]
      const contentDocId = notif?.payload?.contentDocId
      if (baseRoute && contentDocId) {
        navigate(`/${baseRoute}/${PAGES_ROUTES.PageTypeView}/${contentDocId}`)
      }
    } catch (error) {
      console.error('Error handling notification click:', error)
    }
  }

  const hasUnread = notifications.some(
    (item) => item.userNotificationStatus && !item.userNotificationStatus.isRead,
  )

  const displayNotificationItemList = () => {
    if (loading) return <div style={{ padding: 24, textAlign: 'center' }}>Loading...</div>
    if (notifications.length === 0)
      return (
        <div className={styles.notificationListEmpty}>
          <img
            src={notificationFlag}
            alt='No notifications'
            className={styles.notificationListFlag}
          />
          <div className={styles.notificationListEmptyTitle}>No notifications to show.</div>
          <div className={styles.notificationListEmptyDesc}>
            You’ll see updates here when something new comes in.
          </div>
        </div>
      )

    return notifications.map((notif, idx) => (
      <button
        key={notif._id + idx}
        className={`${styles.notificationListItem}${
          notif.userNotificationStatus?.isRead ? '' : ' ' + styles.unread
        }`}
        onClick={() => handleNotificationClick(notif)}
      >
        {!notif.userNotificationStatus?.isRead && (
          <span className={styles.notificationListDot} data-testid='notification-dot' />
        )}
        <div className={styles.notificationListItemTitle}>{notif.title}</div>
        <div className={styles.notificationListItemDesc}>{notif.description}</div>
        <div className={styles.notificationListItemDate}>
          {notif.updatedAt
            ? `${new Date(notif.updatedAt).toLocaleDateString()} ${new Date(
                notif.updatedAt,
              ).toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              })}`
            : ''}
        </div>
      </button>
    ))
  }

  return (
    <div className={styles.notificationListRoot}>
      <div className={styles.notificationListHeader}>
        <span className={styles.notificationListTitle}>Notifications</span>
        <button
          className={styles.notificationListMarkall}
          onClick={hasUnread ? handleMarkAllAsRead : undefined}
          style={{
            cursor: hasUnread ? 'pointer' : 'default',
            opacity: hasUnread ? 1 : 0.5,
            pointerEvents: hasUnread ? 'auto' : 'none',
            color: '#402080',
          }}
        >
          Mark All as Read
        </button>
      </div>
      <div className={styles.notificationListTabs}>
        <button
          className={`${styles.notificationListTab} ${
            tab === 'my' ? styles.selected : ''
          } border-none transparent-background`}
          onClick={() => setTab('my')}
        >
          My Notifications
        </button>
        <button
          className={`${styles.notificationListTab} ${
            tab === 'others' ? styles.selected : ''
          } border-none transparent-background`}
          onClick={() => setTab('others')}
        >
          Others
        </button>
      </div>
      <div className={styles.notificationListScroll}>{displayNotificationItemList()}</div>
      <div className={styles.notificationListFooter}>
        <button
          className={styles.notificationListAllBtn}
          disabled={notifications.length === 0}
          onClick={() => {
            if (onClose) onClose()
            navigate(`${PAGES_ROUTES.AllNotification}?tab=${tab}`)
          }}
        >
          All Notifications
        </button>
      </div>
    </div>
  )
}

export default NotificationList
